'use client';

import { ContainerLG } from '..';
import { Button, H2LG, I_playfair } from './StyleConstants';
import { CustomImage as Image } from '..';
import styles from './StoresSection.module.css';
import CustomLink from 'components/shared/CustomLink';
import { MouseEvent } from 'react';
import { useTranslations } from 'next-intl';

const storesData = [
  // {
  //   name: 'PRINTEMPS, PARIS',
  //   image: 'web_v2/rare/stores/Printemps.png',
  //   href: 'https://maps.app.goo.gl/Q3a4CLdgjWwDiF49A',
  // },
  {
    name: 'SELFRIDGES, LONDON',
    image: 'web_v2/rare/stores/Selfridges.png',
    href: 'https://maps.app.goo.gl/FJUt4cN4cz7zdBSA7',
  },
  {
    name: 'OM JEWELLERS, MUMBAI',
    image: 'web_v2/rare/stores/Om_jewellers.png',
    href: 'https://maps.app.goo.gl/DyyjdBa456ShnFZA8',
  },
];

export const StoresSection = () => {
  const t = useTranslations('ring');

  return (
    <section className={styles.root} id="rare-stores">
      <ContainerLG>
        <H2LG>
          {t.rich('ring.rare.stores.heading', {
            o: (chunks) => <I_playfair>{chunks}</I_playfair>,
          })}
        </H2LG>
        <div className="cards-container">
          {storesData.map((store, index) => (
            <CustomLink
              className="card-element"
              key={index}
              href={store.href}
              target="_blank"
              onMouseMove={(e: MouseEvent<HTMLAnchorElement>) => {
                if (!e.currentTarget.querySelector('.visit-hover')) return;
                (
                  e.currentTarget.querySelector('.visit-hover') as HTMLElement
                ).style.top = `${
                  e.clientY - e.currentTarget.getBoundingClientRect().top + 10
                }px`;
                (
                  e.currentTarget.querySelector('.visit-hover') as HTMLElement
                ).style.left = `${
                  e.clientX - e.currentTarget.getBoundingClientRect().left + 10
                }px`;
              }}
              onMouseLeave={(e: MouseEvent<HTMLAnchorElement>) => {
                if (!e.currentTarget.querySelector('.visit-hover')) return;
                (
                  e.currentTarget.querySelector('.visit-hover') as HTMLElement
                ).style.opacity = '0';
              }}
              onMouseEnter={(e: MouseEvent<HTMLAnchorElement>) => {
                if (!e.currentTarget.querySelector('.visit-hover')) return;
                (
                  e.currentTarget.querySelector('.visit-hover') as HTMLElement
                ).style.opacity = '1';
              }}
            >
              <Image
                src={store.image}
                alt={store.name}
                width="1200"
                height="745"
              />
              <Button>{store.name}</Button>
              <span className="visit-hover">
                {t('ring.rare.stores.visitHere')}
              </span>
            </CustomLink>
          ))}
          {/* <div className="card-element">
            <div className="image-container">
              <Image src="" alt="" width="900" height="540" />
            </div>
            <Button>Store Lorem</Button>
          </div> */}
        </div>
      </ContainerLG>
    </section>
  );
};
